<template>
	<div class="container__parcelainfo__open">
		<div class="container__parcelainfo__open__title">
			<div style="display: flex; flex-direction: column; gap: 0.3rem">
				<span style="font-size: 0.7rem">{{ $t('plot') }}</span>
				<span>{{ parcelaInfo.codigo }}</span>
			</div>
		</div>
		<div class="container__parcelainfo__open__info">
			<div class="container__parcelainfo__open__info__values">
				<span>{{ $t('plotArea') }}</span>
				<span>
					{{ parcelaInfo.area ? `${parcelaInfo.area} (m²)` : $t('notInformed') }}
					<!-- <span>/ {{ plantioMarker.areaDoTalhao }} (ha)</span> -->
				</span>
				<!-- <span>
              {{ plantioMarker.porcentagemDeAreaPlantadaNoTalhao }}% da área do
              talhão plantada
            </span> -->
			</div>
			<div class="container__parcelainfo__open__info__poligono">
				<!-- <PoligonoSvg :infoGeo="plantioMarker.infoPoligono" /> -->
			</div>
		</div>
		<div class="container__parcelainfo__open__info">
			<div class="container__parcelainfo__open__info__values">
				<span>{{ $t('plotFormat') }}</span>
				<span> {{ parcelaInfo.formato ? parcelaInfo.formato : $t('notInformed') }}</span>
			</div>
			<div class="container__parcelainfo__open__info__values right">
				<span>Data de Fechamento</span>
				<span>
					{{
						parcelaInfo.dataDeFechamento
							? `${new Date(parcelaInfo.dataDeFechamento).toLocaleDateString()}`
							: $t('open')
					}}</span
				>
			</div>
		</div>
		<div
			style="flex-direction: column"
			class="container__parcelainfo__open__info"
		>
			<div class="container__parcelainfo__open__info__values">
				<span>{{ $t('latitude') }}</span>
				<span> {{ parcelaInfo.coordenadaY }}</span>
			</div>
			<div class="container__parcelainfo__open__info__values">
				<span>{{ $t('longitude') }}</span>
				<span> {{ parcelaInfo.coordenadaX }}</span>
			</div>
		</div>
		<div class="container__parcelainfo__open__action__buttons">
			<Button
				style="font-size: 0.7rem"
				:label="$t('disregardPlot')"
				semantic-class="tiny"
				outlined
				color="trv-error"
				@click="$emit('desconsideraParcela', parcelaInfo.codigo)"
			/>
			<Button
				v-if="!parcelaInfo.dataDeFechamento"
				style="font-size: 0.7rem"
				:label="$t('closePlot')"
				semantic-class="tiny"
				outlined
				@click="closePlot()"
			/>
			<Button
				v-else
				style="font-size: 0.7rem"
				:label="$t('openPlot')"
				semantic-class="tiny"
				outlined
				@click="openPlot()"
			/>
		</div>
	</div>
</template>

<script>
// import GmapCustomMarker from "vue2-gmap-custom-marker";
// import PoligonoSvg from "../../../../../components/PoligonoSvg/PoligonoSvg";
import Button from '../Button/Button'
import { openPlot, closePlot } from '../../services/requests/OrdemDeServicoRequests'
import { useMessagesStore } from '../../store/modules/moduleMessages.js'

const messagesStore = useMessagesStore()

export default {
	name: 'ParcelaInfo',
	components: {
		Button,
		// GmapCustomMarker,
		//PoligonoSvg
	},

	props: {
		/**
		 * Informacoes do marker e do plantio que devem ser colocados no mapa
		 */
		parcelaInfo: Object,
		ordemServicoId: String,
		dataFechamentoOS: String,
	},

	methods: {
		openPlot() {
			console.log('prop parcela:', this.parcelaInfo, this.ordemServicoId, this.dataFechamentoOS)
			const dadosRequisicao = {
				Id_Parcela: this.parcelaInfo.id,
				Id_Ordem_Servico: this.ordemServicoId,
				Dt_Fechamento: this.parcelaInfo.dataDeFechamento,
			}

			if (this.dataFechamentoOS && this.dataFechamentoOS.trim() !== '') {
				messagesStore.commit('mutationShowMessage', {
					messageTitle: this.$t('erro'),
					messageText: this.$t('serviceOrderClosed'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			} else {
				openPlot(dadosRequisicao).then((res) => {
					if (res.data.statusCode === 200) {
						messagesStore.commit('mutationShowMessage', {
							messageTitle: this.$t('sucesso'),
							messageText: this.$t('plotOpened'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})

						this.parcelaInfo.dataDeFechamento = ''
					} else {
						messagesStore.commit('mutationShowMessage', {
							messageTitle: this.$t('erro'),
							messageText: this.$t('plotNotOpened'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			}
		},

		closePlot() {
			console.log('prop parcela:', this.parcelaInfo, this.ordemServicoId, this.dataFechamentoOS)
			const dadosRequisicao = {
				Id_Parcela: this.parcelaInfo.id,
				Id_Ordem_Servico: this.ordemServicoId,
				Dt_Fechamento: this.parcelaInfo.dataDeFechamento,
			}

			if (this.dataFechamentoOS && this.dataFechamentoOS.trim() !== '') {
				messagesStore.commit('mutationShowMessage', {
					messageTitle: this.$t('erro'),
					messageText: this.$t('serviceOrderClosed'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			} else if (!this.parcelaInfo.existente) {
				// Parcela criada no planejamento e ainda não salva: o id é um uuid local que o backend
				// não conhece, então o fechamento falharia
				messagesStore.commit('mutationShowMessage', {
					messageTitle: this.$t('atencao'),
					messageText: this.$t('plotNotSavedToClose'),
					messageIcon: 'fas fa-exclamation-triangle',
					messageType: 'warning',
				})
			} else {
				closePlot(dadosRequisicao).then((res) => {
					if (res.data.statusCode === 200) {
						messagesStore.commit('mutationShowMessage', {
							messageTitle: this.$t('sucesso'),
							messageText: this.$t('plotClosed'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})

						const [day, month, yearAndTime] = res.data.result.dt_Fechamento.split('/')
						const [year] = yearAndTime.split(' ')
						this.parcelaInfo.dataDeFechamento = `${year.trim()}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`
					} else {
						messagesStore.commit('mutationShowMessage', {
							messageTitle: this.$t('erro'),
							messageText: this.$t('plotNotClosed'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			}
		},
	},
}
</script>

<style scoped>
.container__parcelainfo {
	cursor: default;
	font-family: 'Open Sans', sans-serif;
	background-color: transparent;
}

.container__parcelainfo__open {
	padding-top: 0.5rem;
	display: block;
}

.container__parcelainfo__open {
	display: flex;
	flex-direction: column;
	min-width: 20rem;
}

.container__parcelainfo__open__title {
	display: flex;
	font-size: 1.5rem;
	font-weight: 700;
	color: rgb(var(--color-default));
	line-height: 1rem;
}

.container__parcelainfo__open__info {
	display: flex;
	justify-content: space-between;
}

.container__parcelainfo__open__info__values {
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}

.container__parcelainfo__open__info__values.right {
	align-items: flex-end;
}

.container__parcelainfo__open__info__values > span:first-child {
	font-size: 0.75rem;
	color: var(--color-gray-dark);
	font-weight: 500;
}

.container__parcelainfo__open__info__values > span:nth-child(2) {
	font-size: 1.2rem;
	font-weight: 700;
}

.container__parcelainfo__open__info__values > span:nth-child(2) > span:first-child {
	font-size: 0.75rem;
	font-weight: 500;
}

.container__parcelainfo__open__info__values > span:nth-child(3) {
	background-color: rgba(var(--color-default), 0.2);
	color: rgb(var(--color-default));
	padding: 0 0.5rem;
	border-radius: 10px;
	font-weight: 600;
}

.container__parcelainfo__open__info__poligono {
	height: 5rem;
	width: 5rem;
}

.container__parcelainfo__open__info__progress {
	height: 5px;
	width: 100%;
	background-color: rgba(var(--color-rgb-gray), 0.3);
	border-radius: 25px;
	overflow: hidden;
}

.container__parcelainfo__open__info__progress > div {
	height: 5px;
	background-color: rgb(var(--color-default));
}

.container__parcelainfo__open__action__buttons {
	display: flex;
	margin-top: 0.5rem;
}
</style>
